import { Inject, Injectable } from "@angular/core";
import { AuthenticationModel, CheckUtils, EncryptStorageEvent, logger, OrganizationProvider, UserTeamsConverter, UserTeamsEndPoints, UserTeamsModel } from "../..";
import { Events } from "ionic-angular";
import { OdConfig, OrganizationModel } from "../../index";
import { CacheService } from "ionic-cache";
var UserTeamsProvider = /** @class */ (function () {
    function UserTeamsProvider(config, userTeamsEndPoints, _model, _events, _cache, authModel, _organizationModel, organizationProvider) {
        this.config = config;
        this.userTeamsEndPoints = userTeamsEndPoints;
        this._model = _model;
        this._events = _events;
        this._cache = _cache;
        this.authModel = authModel;
        this._organizationModel = _organizationModel;
        this.organizationProvider = organizationProvider;
        this._ready = false;
        this.bind();
    }
    UserTeamsProvider.prototype.bind = function () {
        var _this = this;
        this._events.subscribe(EncryptStorageEvent.SECRET_PASSPHRASE_CHANGED, function (res) {
            _this._model.clear(false, true);
            if (res)
                _this._model.loadEncryptData();
        });
        this._events.subscribe(this._organizationModel.event.URI_CHANGED, function () {
            _this._model.clear(false, true);
        });
        this._events.subscribe(this._model.event.LOADED, function () {
            _this._ready = true;
            _this._events.publish(UserTeamsProviderEvent.READY, _this._ready);
        });
    };
    Object.defineProperty(UserTeamsProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserTeamsProvider.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    UserTeamsProvider.prototype.get = function (userTeamsId, callback) {
        var result = new Map();
        if (CheckUtils.isEmpty(userTeamsId))
            return result;
        var toLoad = new Set();
        for (var _i = 0, _a = Array.from(userTeamsId); _i < _a.length; _i++) {
            var userTeamId = _a[_i];
            var userTeam = this._model.get(userTeamId);
            if (CheckUtils.isEmpty(userTeam))
                toLoad.add(userTeamId);
            else
                result.set(userTeam.id, userTeam);
        }
        if (CheckUtils.isEmpty(toLoad)) {
            callback(result);
        }
        else {
            this.load(toLoad, function (userTeams) {
                for (var _i = 0, userTeams_1 = userTeams; _i < userTeams_1.length; _i++) {
                    var userTeam_1 = userTeams_1[_i];
                    result.set(userTeam_1.id, userTeam_1);
                }
                callback(result);
            });
        }
    };
    UserTeamsProvider.prototype.load = function (userTeamsIds, callback) {
        var _this = this;
        var userTeams = [];
        this.userTeamsEndPoints.get(this._organizationModel.uri, userTeamsIds).then(function (res) {
            if (res != null) {
                for (var _i = 0, res_1 = res; _i < res_1.length; _i++) {
                    var userTeam = res_1[_i];
                    userTeams.push(UserTeamsConverter.convertToUserTeamVoData(userTeam));
                }
                _this._model.addAll(userTeams);
                if (callback != null)
                    callback(userTeams);
            }
        }).catch(function (err) {
            if (callback != null)
                callback(userTeams);
            logger.info(err);
        });
    };
    UserTeamsProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UserTeamsProvider.ctorParameters = function () { return [
        { type: OdConfig, decorators: [{ type: Inject, args: ['config',] },] },
        { type: UserTeamsEndPoints, },
        { type: UserTeamsModel, },
        { type: Events, },
        { type: CacheService, },
        { type: AuthenticationModel, },
        { type: OrganizationModel, },
        { type: OrganizationProvider, },
    ]; };
    return UserTeamsProvider;
}());
export { UserTeamsProvider };
export var UserTeamsProviderEvent;
(function (UserTeamsProviderEvent) {
    UserTeamsProviderEvent["READY"] = "user-teams-provider:ready";
})(UserTeamsProviderEvent || (UserTeamsProviderEvent = {}));
//# sourceMappingURL=user-teams-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/user/user-teams-provider.js
// module id = 346
// module chunks = 14